var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.content},[_c('icon',{attrs:{"name":_vm.iconName,"width":"60","height":"60"}}),_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.$t(_vm.labelI18n)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }